<script>
  import PageTitle from "$lib/components/Page/PageTitle.svelte";
  import JumpLinks from "$lib/components/MenuTypes/JumpLinks.svelte";
  import Bleed from "$lib/components/Bleed.svelte";
  import Image from "$lib/components/Image.svelte";
  import LinkComponent from "$lib/contentTypes/LinkComponent.svelte";
  import RichText from "../RichText.svelte";

  import { buildSrc, altTextToDisplay } from "$lib/utilities";
  import { setContext } from "svelte";

  /** @type {"background" | "fixed-background" | "featured" | "gradient"} */
  export let variant;
  export let title;
  export let featuredImage;
  export let logo;
  export let cta;
  export let links;
  export let bgColor;
  export let richTextContent;
  export let toggleRichTextContent;

  export let backgroundClasses = ["background", "fixed-background"].includes(variant)
    ? "bg-no-repeat bg-cover bg-center"
    : "";
  export let containedClasses =
    variant === "background"
      ? "py-100 lg:py-215 px-36 lg:px-230"
      : "py-48 lg:py-72 px-24 lg:px-230";
  export let logoClasses =
    variant === "background" ? "max-h-[160px] lg:max-h-[250px]" : "max-h-[90px] lg:max-h-[120px]";
  export let mobileTextSize = variant === "background" ? "text-size-20 " : "text-size-24";

  setContext("isLandingPageHeroChild", true);

  const logoAltText = altTextToDisplay(logo?.fields.altText);
  const featuredImageAltText = altTextToDisplay(featuredImage?.fields.altText);
  // Note: Styles used rather than classes because these are fully dynamic and tailwind does not support
  // for background elements.
  const backgroundImageUrl = buildSrc(featuredImage?.fields.imageAsset, { w: 3000 });
  const backgroundImageStyle = ["background", "fixed-background"].includes(variant)
    ? `background-image: url('${backgroundImageUrl}');`
    : "";
  const ctaId = cta?.destination?.sys?.id ? `cta-${cta?.destination?.sys?.id}` : "";
</script>

<div class="hero w-full" test-id="hero">
  <Bleed
    fullWidth
    fullWidthClasses={backgroundClasses}
    fullWidthStyles="background-color: {bgColor}; {backgroundImageStyle}"
  >
    <div class="w-full lg:max-w-screen-lg mx-auto">
      {#if !toggleRichTextContent || !richTextContent}
        <div class="flex flex-col gap-40 overflow-hidden {containedClasses}">
          {#if logo}
            <Image
              containerClass="flex justify-center"
              elementClass="w-auto {logoClasses}"
              asset={logo.fields.imageAsset}
              alt={logoAltText}
              resizeParams={{ fm: "" }}
            />
          {/if}

          {#if title?.trim()}
            <PageTitle
              class="{mobileTextSize} lg:text-size-40 hover:!no-underline active:!no-underline focus:!no-underline"
              {title}
            />
          {/if}

          {#if cta}
            <LinkComponent data={{ ...cta }} id={ctaId} class="mx-auto" />
          {/if}

          {#if links}
            <JumpLinks
              data={links}
              class="bg-none m-0 p-0 border-none flex-wrap justify-center"
              linkClasses="!bg-none"
            />
          {/if}
        </div>
      {:else}
        <RichText node={richTextContent} />
      {/if}
    </div>

    {#if !["background", "fixed-background"].includes(variant) && featuredImage}
      <Image
        containerClass="w-full max-w-screen-lg mx-auto lg:max-h-621 overflow-hidden"
        elementClass="w-full"
        asset={featuredImage.fields.imageAsset}
        alt={featuredImageAltText}
        resizeParams={{ fm: "webp" }}
      />
    {/if}
  </Bleed>
</div>
